// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelectorAll('.mobilemenu');
    burgerButton.forEach(item => {
        console.log(item)
        item.addEventListener('click', function () {
            console.log('a')
            document.body.classList.toggle('mobilmenuopen');
        });
    });
}
